import axios from 'axios';
//import store from '../store';
import CryptoJS from 'crypto-js';
import Keys from '@/store/keys';
const intance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
        "Content-type": "application/json",
        'Accept' : 'application/json',
    }
});

// Menambahkan interceptor request
intance.interceptors.request.use(
    (config) => {
        // Ambil token dari local storage atau tempat penyimpanan lainnya
        //const auth = localStorage.getItem('tkn');

        const y_token   = localStorage.getItem('x_token') ;
        const y_access  = localStorage.getItem('x_access');
        const y_keys    = localStorage.getItem('x_keys')  ;
        const y_public  = localStorage.getItem('x_public');

        const b_token   = y_token ? CryptoJS.AES.decrypt( y_token, Keys.state.public).toString(CryptoJS.enc.Utf8)   : "";
        const b_access  = y_access? CryptoJS.AES.decrypt( y_access, Keys.state.public).toString(CryptoJS.enc.Utf8)  : "";
        const b_keys    = y_keys  ? CryptoJS.AES.decrypt( y_keys, Keys.state.public).toString(CryptoJS.enc.Utf8)    : "";
        const b_public  = y_public? CryptoJS.AES.decrypt( y_public, Keys.state.public).toString(CryptoJS.enc.Utf8)  : "";

        const real_token= b_token + b_access + b_keys + b_public;
        // Jika token ada, tambahkan header Authorization ke setiap permintaan
        if (real_token) {
            config.headers['Authorization'] = `Bearer ${real_token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

intance.interceptors.response.use(
    (response) => response,
    (error) => Promise.reject(error)
);

export default intance;
